import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { setProductDashboardProductList, setSelectedPharmaorderId,setProductassetList } from 'store/slice/PharmaSlice';
import { setProductList } from 'store/slice/PharmaSlice';
import { getListAPI as getProductassetList } from 'components/productasset/ProductassetAPI';
import { getListAPI as getProductList } from 'components/product/ProductAPI';

import ProductDashboard from '../ProductDashboard';

export default function QaProductPage() {
    const dispatch = useDispatch();
    const {productList} = useSelector((state)=>state.pharmaslice)
    const getProductListSuccess = (list) =>{dispatch(setProductList(list));}
    const getProductassetListSuccess = (list) =>{dispatch(setProductassetList(list));}
    const {taskList} = useSelector((state) => state.appslice.wkflow);

    useEffect(() => {
        dispatch(setSelectedPharmaorderId(-1));
        dispatch(openDrawer(false));
        getProductList(()=>{}, getProductListSuccess);

        getProductassetList(()=>{}, getProductassetListSuccess);
    },[]);

    useEffect(()=>{
        // Get all boObjId from taskList where taskstatusid is 2
        const boObjIds = taskList
            .filter(task => task.taskstatusid === 2)
            .map(task => task.boobjid);
        dispatch(setProductDashboardProductList(
            productList.filter(productObj => boObjIds.includes(productObj.id))
        ));
    }, [productList, taskList]);

    return (
        <ProductDashboard/>
    )

}